// extracted by mini-css-extract-plugin
export default {"HomePosts":"AllPosts_HomePosts__K9c70","Loading":"AllPosts_Loading__cJn5G"};